import React from 'react';

import sy from '~/styles';
import {Text} from '~/components/controls';

import {resolveTaskSubtitleData} from '../helper';
import PropTypes from 'prop-types';

const TaskSubtitle = ({
  lessor,
  tasks,
  is_maintenance_item,
  is_tires_item,
  is_sla_item,
  ready,
  enabled,
  cancelled,
  cancellation_approved,
  cancellation_denied,
  rob_components,
  is_fleet_car,
  is_retail_car,
}) => {
  const subtitleData = resolveTaskSubtitleData({
    lessor,
    tasks,
    is_maintenance_item,
    is_tires_item,
    is_sla_item,
    ready,
    rob_components,
    is_fleet_car,
    is_retail_car,
  });

  let content;
  if (subtitleData.text) {
    content = <>{subtitleData.text}</>;
  } else {
    content = (
      <>
        {subtitleData.type}
        {subtitleData.operations?.length > 0 ? (
          <>&nbsp;&middot;&nbsp;{subtitleData.operations.join(', ')}</>
        ) : (
          <></>
        )}
      </>
    );
  }

  return (
    <Text
      style={[
        sy.truncate,
        sy.small,
        sy['text-lightgray'],
        enabled && sy['underline'],
        (cancelled || cancellation_approved || cancellation_denied) &&
          sy['line-through'],
      ]}>
      {content}
    </Text>
  );
};
TaskSubtitle.propTypes = {
  lessor: PropTypes.any,
  tasks: PropTypes.any,
  is_maintenance_item: PropTypes.any,
  is_tires_item: PropTypes.any,
  is_sla_item: PropTypes.any,
  ready: PropTypes.any,
  enabled: PropTypes.any,
  cancelled: PropTypes.any,
  cancellation_approved: PropTypes.any,
  cancellation_denied: PropTypes.any,
  rob_components: PropTypes.any,
  is_fleet_car: PropTypes.any,
  is_retail_car: PropTypes.any,
};

export default TaskSubtitle;
